var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.value.label}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.value.label,"disabled":_vm.disabled},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }